var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number)?_c('div',{staticClass:"progress-icon",class:{
        'is-complete': _vm.isComplete && !_vm.isPending,
        'is-pending': _vm.isPending,
    }},[(!_vm.isComplete || _vm.isPending)?[_vm._v(_vm._s(_vm.number))]:_c('svg-icon',{attrs:{"name":"success"}})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }